export default "__VITE_PUBLIC_ASSET__ae4bb362__"